import { type ReactNode } from 'react';
import styles from './badge.module.scss';

const Badge = ({
	text,
	icon,
	backgroundColor = 'var(--color-white-opaque-85)',
	color = 'currentColor',
	borderColor,
}: Props) => {
	const borderColorOverride = borderColor ? { borderColor } : {};
	return (
		<div
			className={styles.badge}
			style={{ color, backgroundColor, ...borderColorOverride }}
		>
			{icon || null}
			{text}
		</div>
	);
};

export interface Props {
	backgroundColor?: string;
	borderColor?: string;
	color?: string;
	icon?: ReactNode;
	text: string;
}

export default Badge;
